<template>
      <mds-loader  aria-label="Medium Loader" aria-valuetext="Loading..."></mds-loader>
</template>

<script>
import MdsLoader from "@mds/loader-vue3";

export default {
    name: 'ModelLoader',
    components:{MdsLoader}
}
</script>